import { IRecord, IRecordType } from 'annotation-tools/utils';

// immutable object generator
export const IKoumuten = IRecord<KoumutenType>({
  id: 0,
  name: '',
  dateCreated: 0,
  dateUpdated: 0,
  numCompanies: 0,
  author: '',
  canBeDeleted: false
});

// immutable type
export type IKoumutenType = IRecordType<KoumutenType>;

type KoumutenType = {
  id: number;
  name: string; // 工務店名 [1..50] characters
  dateCreated: number;
  dateUpdated: number;
  numCompanies: number; // 設計会社数
  author: string;
  canBeDeleted: boolean;
};
